import React, { StrictMode } from 'react';
import { Page } from '@bxp-spaces/trello';
import { HelmetProvider } from 'react-helmet-async';
import { GlobalStyles, AnalyticsProvider, RouteProvider } from '@bxp-spaces/trello';
export const APP_ID = 'BXP-APP';
export function App({ defaultPageModel, helmetContext }) {
    return (React.createElement(StrictMode, null,
        React.createElement(RouteProvider, { value: defaultPageModel.content.route.content.path },
            React.createElement(HelmetProvider, { context: helmetContext },
                React.createElement(AnalyticsProvider, null,
                    React.createElement(GlobalStyles, null),
                    React.createElement(Page, { model: defaultPageModel }))))));
}
//# sourceMappingURL=app.js.map